import { useEffect } from 'react'
import { useNavigate, useRouteError } from 'react-router-dom'
import styled from 'styled-components'
import { captureError } from 'src/utils/sentry'

const ErrorBoundaryPage = (): JSX.Element => {
  const navigate = useNavigate()
  const error = useRouteError()

  useEffect(() => {
    if (!error) return
    if (!(error instanceof Error)) return

    captureError(error)
  }, [error])

  const pageBackHandler = () => {
    navigate(-1)
  }
  const pageReloadHandler = () => {
    window.location.reload()
  }

  return (
    <ErrorBoundaryWrap>
      <ErrorContents>
        <ErrorIcon viewBox="0 0 48 48" aria-hidden>
          <circle cx="24" cy="24" r="20" fill="none" stroke="#717580" strokeWidth="2" />
          <rect x="22" y="12" width="4" height="16" rx="2" fill="#717580" />
          <circle cx="24" cy="34" r="2.5" fill="#717580" />
        </ErrorIcon>
        <ErrorText>페이지를 찾을 수 없습니다.</ErrorText>
        <ErrorReloadButton type="button" onClick={pageReloadHandler}>
          새로고침
        </ErrorReloadButton>
        <ErrorPageBackButton type="button" onClick={pageBackHandler}>
          뒤로가기
        </ErrorPageBackButton>
      </ErrorContents>
    </ErrorBoundaryWrap>
  )
}

export default ErrorBoundaryPage

const ErrorBoundaryWrap = styled.div`
  min-height: 100vh;
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`

const ErrorContents = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 16px;
`

const ErrorIcon = styled.svg`
  width: 48px;
  height: 48px;
  margin: 0 auto;
`

const ErrorText = styled.p`
  margin-top: 28px;
  margin-bottom: 70px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #717580;
`

const ErrorPageButton = styled.button`
  width: 260px;
  margin: 0 auto;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;
  background: #fff;
`

const ErrorReloadButton = styled(ErrorPageButton)`
  color: #252838;
  border: 1px solid #ccd0d8;
  height: 38px;
  margin-bottom: 10px;
`

const ErrorPageBackButton = styled(ErrorPageButton)`
  color: #717580;
  height: 38px;
  border: none;
`
